import type {DalValue, Pointer, VariantRelation} from '@wix/document-services-types'
import {removePrefix} from '@wix/document-manager-utils'
import _ from 'lodash'
import type {DalItem} from '@wix/document-manager-core'

export interface VariantRelationPossiblySerialized extends Omit<VariantRelation, 'to' | 'remoteVariants' | 'id'> {
    to: DalValue
    remoteVariants?: string[]
}

const REF_PREFIX = '#'

const RELATION_DATA_TYPES = {
    VARIANTS: 'VariantRelation'
}
const {VARIANTS} = RELATION_DATA_TYPES
const refCompDelimiter = '_r_'

const isLocalVariant = (variant: string | Pointer, separateRemoteVariants?: boolean) => {
    if (!separateRemoteVariants) {
        return true
    }
    const id = _.isString(variant) ? variant : variant.id
    return !id.includes(refCompDelimiter)
}
const variantRelation = {
    create: (variants: string[], from: string, to: string | DalItem, separateRemoteVariants?: boolean) => {
        const result: VariantRelationPossiblySerialized = {
            type: VARIANTS,
            variants: _(variants)
                .filter((v: string | Pointer) => isLocalVariant(v, separateRemoteVariants))
                .map(v => (_.isString(v) ? `#${removePrefix(v, REF_PREFIX)}` : v))
                .value(),

            from: `#${from}`,
            to: _.isString(to) ? `#${to}` : to
        }
        if (!separateRemoteVariants) {
            return result
        }
        const remoteVariants = _(variants)
            .filter((v: string | Pointer) => !isLocalVariant(v, separateRemoteVariants))
            .map(v => (_.isString(v) ? `#${removePrefix(v, REF_PREFIX)}` : v))
            .value()
        if (remoteVariants.length > 0) {
            result.remoteVariants = remoteVariants
        }
        return result
    }
}

export const createVariantRelation = variantRelation.create
